var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { dataTableConfigFields } from '../../DataTable/DataTableFormioIntegration';
export default __spreadArrays([
    {
        type: 'textfield',
        label: 'Image Url',
        input: true,
        key: 'imageUrl',
        weight: 20,
    },
    {
        type: 'select',
        input: true,
        key: 'imageType',
        label: 'Image Type',
        tooltip: 'Element used to display background image',
        weight: 20,
        defaultValue: 'image',
        dataSrc: 'values',
        data: {
            values: [
                { label: 'Image', value: 'image' },
                { label: 'SVG', value: 'svg' },
            ],
        },
    },
    {
        type: 'textfield',
        label: 'Width',
        input: true,
        key: 'width',
        customConditional: function (_a) {
            var data = _a.data;
            return !data.autoSize;
        },
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Height',
        input: true,
        key: 'height',
        customConditional: function (_a) {
            var data = _a.data;
            return !data.autoSize;
        },
        weight: 20,
    },
    {
        type: 'checkbox',
        label: 'Set Size Automatically',
        input: true,
        key: 'autoSize',
        tooltip: 'Background image will fill the available width. Uncheck this if you want to specify width/height manually.',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Default Zoom',
        input: true,
        key: 'defaultZoom',
        placeholder: '100',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Default Stroke Color',
        description: 'Start with # sign',
        input: true,
        key: 'defaultStroke',
        placeholder: '#333',
        weight: 20,
    },
    {
        type: 'textfield',
        label: 'Default Fill Color',
        description: 'Start with # sign',
        input: true,
        key: 'defaultFill',
        placeholder: '#ccc',
        weight: 20,
    },
    {
        type: 'number',
        label: 'Default Line Width',
        input: true,
        key: 'defaultLineWidth',
        placeholder: '1',
        weight: 20,
    },
    {
        type: 'number',
        label: 'Default Circle Size',
        input: true,
        key: 'defaultCircleSize',
        placeholder: '10',
        weight: 20,
    },
    {
        key: 'placeholder',
        ignore: true
    }
], dataTableConfigFields());
